export type LocaleKey = 'en';

export type LandingCopy = {
  heroTitle: string;
  heroSubtitle: string;
  heroCTA: string;
  heroSecondaryCTA: string;
  heroTagline: string;
  featureSectionTitle: string;
  featureSectionSubtitle: string;
  metricsEyebrow: string;
  metricsTitle: string;
  metricsSubtitle: string;
  testimonialQuote: string;
  testimonialAuthor: string;
  testimonialRole: string;
  clientsTitle: string;
  clientsSubtitle: string;
  pricingTitle: string;
  pricingSubtitle: string;
  footerCTA: string;
};

export type LandingCopyDictionary = Record<LocaleKey, LandingCopy>;

export const LANDING_COPY: LandingCopyDictionary = {
  en: {
    heroTitle: 'Replace 5 agency tools with one your team actually enjoys',
    heroSubtitle:
      'Run every client’s Meta, Google & TikTok — campaigns, reporting, and CRM — from one white-labeled login. No more tab-juggling or spreadsheet nights.',
    heroCTA: 'Start your 14-day agency trial',
    heroSecondaryCTA: 'See pricing',
    heroTagline: 'Built for agencies managing 10–100 client accounts',
    featureSectionTitle: 'Run more clients without hiring more people',
    featureSectionSubtitle:
      'AI campaign optimization, white-label reporting, and a built-in CRM do the work your team is currently doing by hand across five different tools.',
    metricsEyebrow: 'WHY AGENCIES SWITCH',
    metricsTitle: 'Stop stitching together five tools to run one agency',
    metricsSubtitle:
      'One system for campaigns, reporting, and client communication means your team spends less time reconciling dashboards and more time on the work that keeps clients paying.',
    testimonialQuote:
      '"We built Advoltix because agencies were losing margin to tool sprawl — not to a lack of results. One login, one source of truth, client-ready reporting in minutes instead of hours."',
    testimonialAuthor: 'The Advoltix Team',
    testimonialRole: 'Built for performance marketing agencies running paid media for their clients.',
    clientsTitle: 'Built for performance marketing agencies',
    clientsSubtitle: 'From boutique shops to multi-market agencies — Advoltix runs every client from one login.',
    pricingTitle: 'Pricing that scales with your client roster',
    pricingSubtitle: 'One upgrade trigger: how many clients you manage. Everything else is included.',
    footerCTA: 'Ready to run every client from one login?',
  },
};
